import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  selector: '[bomTooltip]',
})
export class TooltipDirective implements OnInit {
  @Input() tutorialSequenceId: string;
  @Input() step: number;
  @Input() placement: 'bottom' | 'top' | 'right' | 'left';

  private tooltipComponent: ComponentRef<TooltipComponent>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private elRef: ElementRef
  ) {}

  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(TooltipComponent);
    this.tooltipComponent = this.viewContainerRef.createComponent(factory);

    this.tooltipComponent.instance.tutorialSequenceId = this.tutorialSequenceId;
    this.tooltipComponent.instance.step = this.step;
    this.tooltipComponent.instance.placement = this.placement;
    this.tooltipComponent.instance.hostElement = this.elRef;
  }
}
